import React, { useState, useEffect, useCallback } from 'react';
import { getData, updateData } from '../../services/uploadAnalyticsServices';
import { Button, Form } from 'react-bootstrap';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';

const UploadAnalytics = () => {
  const [form, setForm] = useState({ id: '', a_code: '', data_studio: '' });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // Fetch data
  const fetchData = useCallback(async () => {
    setLoading(true)
    try {
      const data = await getData();
      if (data && data.length > 0) {
        setForm(data[0]); // Assuming there's only one record to edit
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    finally {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


   // Validate form data
  const validateForm = () => {
  const newErrors = {};
  if (!form.a_code) newErrors.a_code = "GA4 Measurement Id is required";
  if (!form.data_studio) newErrors.data_studio = "Looker Studio Id is required";
  
  setErrors((prev) => ({ ...prev, ...newErrors }));
  return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
}

  // Handle input change
  const handleChange = (e) => {
    try{
        const { name, value } = e.target;
          // Create a copy of the current form data
          let updatedData = { ...form };
          let updatedErrors = { ...errors };
          updatedData[name] = value;
          if (value) {
          updatedErrors[name] = ''; // Clear error if corrected
        }
        setForm(updatedData);
        setErrors(updatedErrors);
      }
      catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  // Handle form submission (update details)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
        return
      }
    try {
      await updateData(form);
      fetchData(); // Refresh data after update
      toast.success("Updated Successfully!", {position: 'top-right', autoClose: 3000,});
    } catch (error) {
      console.error('Error updating data:', error);
    }
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>SEO Config <b>/ Upload Analytics ID</b></p>
            </div>
            <div className="col-4 text-end">
              {/* <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button> */}
            </div>
          </div>
          <Form>
            <div className='row'>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>GA4 Measurement Id <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="a_code"
                value={form.a_code}
                onChange={handleChange}
                isInvalid = {!!errors.a_code}
              />
                <Form.Control.Feedback type="invalid">{errors.a_code}</Form.Control.Feedback>               

            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Looker Studio Id<small className='text-danger'>*</small></Form.Label>
              <Form.Control
                type="text"
                name="data_studio"
                value={form.data_studio}
                onChange={handleChange}
                isInvalid = {!!errors.data_studio}
              />
              <Form.Control.Feedback type="invalid">{errors.data_studio}</Form.Control.Feedback>               
            </Form.Group>
            </div>
            <Button variant="success" onClick={handleSubmit}>Submit</Button>
          </Form>
        </div>
        <Footer />
        </div>
      )}
      </div>
    </div>
  );
};

export default UploadAnalytics;
